// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"background-image-layout_outerContainer__22zk8","innerContainer":"background-image-layout_innerContainer__1eagC"};